import MrMonkey from "../assets/photos/Mr.Monkey.png";
import ReadBuddy from "../assets/photos/ReadBuddy.png";
import DareVenture from "../assets/photos/DareVenture.png";
import DareVentureHome from "../assets/photos/DareVenture_Home.png";
import BrigAI from "../assets/photos/brig.png";
import BrigAIPage from "../assets/photos/SymptomPage.png";

export const ProjectList = [
    {
        name: "Brig.ai",
        image: BrigAI,
        displayimage: BrigAIPage,
        //about: "   is a web application that empowers women by providing them with tools and knowledge to advocate for their health, particularly addressing issues like medical dismissal and misdiagnosis in conditions such as PCOS and Endometriosis.",
        link: "https://github.com/DorisWZhang/Brig.ai",
        tech: "Python, Flask, Pandas, NumPy, SklearN, React, JavaScript",
    },
    {
        name: "Campus Cart",
        image: BrigAI,
        link: "https://github.com/DorisWZhang/marketplace-frontend",
        tech: "Java, Springboot, PostgreSQL, Google Maps API, React, JavaScript",

    },
    {
        name:"Mr. Monkey ChildWork Toolkit",
        image: MrMonkey,
        displayimage: MrMonkey,
        //about: "   is an all-encompassing application containing necessary resources for leaders such as elementary school teachers and camp counsellors working with children. This program contains features such as a user account system, an activity database with over 35+ games, seating generator, random name picker, and so much more!",
        link: "https://github.com/DorisWZhang/Mr.Monkey",
        tech: "Java, Java Swing"
        
    },
    {
        name: "DareVenture",
        image: DareVenture,
        displayimage: DareVentureHome,
        //about: "   is a mobile app where users are given daily prompts for wellness activities. Users can maintain their streak and earn venture points by completing the daily activity, which can be used to redeem discounts towards products of partnering outdoor apparel and equipment companies. Not only will users enjoy discounted items while working towards a healthy lifestyle, but DareVenture will also be able to work with a wide market in the fitness and wellbeing industry.",
        link: "https://github.com/DorisWZhang/DareVenture",
        tech: "React Native, JavaScript, HTML/CSS"
    },
    
    {
        name: "ReadBuddy",
        image: ReadBuddy,
        displayimage: ReadBuddy,
        //about: "  an online chrome extension aimed to provide users with dyslexia a comfortable reading experience across all websites. This extension allows users to customize features of the website’s text such as font, font size, word-spacing, and colour, to increase legibility and accommodate their personal preferences.",
        link: "https://github.com/DorisWZhang/ReadBuddy",
        tech: "JavaScript, HTML, CSS"
    },
    
];